module.exports = __webpack_public_path__ + "8fc7c3d1f36e1c6617ff9f6cbab09208.pdf";